export enum ClaimStatusState {
  Active = 'active',
  Closed = 'closed',
  None = 'none',
}
